// 比赛事件编号统一转换为字符串，兼容接口返回数字或字符串的情况。
const normalizeEventId = (eventId) => String(eventId)

export const GOAL_RECORD_EVENT_IDS = Object.freeze([
    '3', '4', '9', '11', '12', '13', '14', '15', '16', '19', '20', '21'
])

// 实际进球不包含乌龙球和点球未进；乌龙球由对方比分逻辑单独处理。
export const SCORE_EVENT_IDS = Object.freeze([
    '3', '11', '12', '13', '14', '15', '16', '19', '20', '21'
])

export const CARD_EVENT_IDS = Object.freeze(['5', '6'])
export const HAPPY_EVENT_ID = '22'

export const EVENT_DESCRIPTIONS = Object.freeze({
    '3': '运动战(其他)',
    '4': '乌龙球',
    '11': '运动战(头球)',
    '12': '点球(右脚)',
    '13': '运动战(左脚)',
    '14': '运动战(右脚)',
    '15': '任意球(右脚)',
    '16': '角球(右脚)',
    '19': '任意球(左脚)',
    '20': '角球(左脚)',
    '21': '点球(左脚)'
})

export const isGoalRecordEvent = (eventId) => GOAL_RECORD_EVENT_IDS.includes(normalizeEventId(eventId))

export const isScoreEvent = (eventId) => SCORE_EVENT_IDS.includes(normalizeEventId(eventId))

export const isCardEvent = (eventId) => CARD_EVENT_IDS.includes(normalizeEventId(eventId))

export const isHappyEvent = (eventId) => normalizeEventId(eventId) === HAPPY_EVENT_ID

export const getEventDescription = (eventId, fallback = '未知事件') => (
    EVENT_DESCRIPTIONS[normalizeEventId(eventId)] || fallback
)
